import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

interface ActionCellProps {
  children: JSX.Element | Array<JSX.Element>;
  icon: BenchlingIconName;
  onClick: (e: ElementMouseEvent) => void;
  isIconVisible?: boolean;
}

/**
 * A table cell with a clickable icon on the right side.
 */
const ActionCell: React.FC<ActionCellProps> = ({
  children,
  icon,
  onClick,
  isIconVisible,
}: ActionCellProps): JSX.Element => (
  <div className="u-vertical-center-items">
    <div className="u-flex-grow u-word-break-word">{children}</div>
    <div className="u-flex-none">
      {isIconVisible && <BenchlingIcon className="stageEntry-actionCellIcon" onClick={onClick} icon={icon} />}
    </div>
  </div>
);

ActionCell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isIconVisible: PropTypes.bool.isRequired,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

ActionCell.defaultProps = {
  isIconVisible: true,
};

export default ActionCell;
